var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMailDt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 14"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 .4H3C1.6.4.4 1.6.4 3v7.6c0 1.4 1.2 2.6 2.6 2.6h13c1.4 0 2.6-1.2 2.6-2.6V3c0-1.4-1.2-2.6-2.6-2.6zm1.4 10.2c0 .8-.6 1.4-1.4 1.4H3c-.8 0-1.4-.6-1.4-1.4V3c0-.8.6-1.4 1.4-1.4h13c.8 0 1.4.6 1.4 1.4v7.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 3.2l-4.6 3.5c-.5.4-1.2.4-1.7 0L4 3.2c-.2-.2-.6-.1-.8.1s-.1.7.1.9l4.6 3.5c.5.4 1 .5 1.6.5.6 0 1.1-.2 1.6-.5l4.6-3.5c.2-.2.3-.6.1-.9s-.6-.3-.9-.1z"
  }))));
}
export default SvgIcMailDt;